import { Account } from 'syf-typings/creditAccounts/creditAccounts'

const findAccount = (accounts: Account[], accountId: string): Account =>
  accounts.find(
    (account: Account) => account.info['cipher.accountId'] === accountId
  )

export default findAccount
